import { API_URL_WEBINAR } from "@constants/env";
import apiInstance from "@services/Shared/instanceAxios";
import TCreateEditWebinar from "types/Webinar/createEditWebinar";

const createWebinar = (newWebinar: TCreateEditWebinar) =>
  apiInstance({
    url: API_URL_WEBINAR,
    method: "post",
    data: newWebinar,
  });

export default createWebinar;
